var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.handleClose,
      expression: "handleClose"
    }],
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.control,
    on: {
      "click": _vm.handleToggle
    }
  }, [_c('div', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 10,
      expression: "10"
    }]
  }, [_vm._v(_vm._s(_vm.$t(_vm.getActiveOption.label)))]), _vm.isVisible ? _c('base-icon', {
    attrs: {
      "name": "arrows_chevron-top",
      "size": 16
    }
  }) : _c('base-icon', {
    attrs: {
      "name": "arrows_chevron-bottom",
      "size": 16
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_vm.isVisible ? _c('div', {
    class: _vm.$style.content
  }, _vm._l(_vm.options, function (option, idx) {
    return _c('router-link', {
      key: idx,
      attrs: {
        "to": {
          name: option.name
        },
        "custom": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var _ref2;

          var navigate = _ref.navigate,
              isExactActive = _ref.isExactActive;
          return [_c('div', {
            class: [_vm.$style.link, (_ref2 = {}, _ref2[_vm.$style.active] = isExactActive, _ref2)],
            on: {
              "click": navigate
            }
          }, [_vm._v(" " + _vm._s(_vm.$t(option.label)) + " ")])];
        }
      }], null, true)
    });
  }), 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }